<template>
  <v-tabs v-model="tab" center-active grow>
    <v-tab :class="{'justify-start': $vuetify.breakpoint.xsOnly}" v-if="event.hasVideoTag()">
      {{ $vuetify.lang.t(`$vuetify.map.criticalPopup.sections.video.tabs.${UploadVideoTypes.DRIVER}`) }}
    </v-tab>
    <v-tab :class="{'justify-start': $vuetify.breakpoint.xsOnly}" v-if="event.hasVideoRoadTag()">
      {{ $vuetify.lang.t(`$vuetify.map.criticalPopup.sections.video.tabs.${UploadVideoTypes.ROAD}`) }}
    </v-tab>

    <v-tabs-items v-model="tab" :touchless="$vuetify.breakpoint.smAndDown">
      <v-tab-item v-if="event.hasVideoTag()">
        <tag-data-table :table-data="tableData" :key="UploadVideoTypes.DRIVER"></tag-data-table>
      </v-tab-item>
      <v-tab-item v-if="event.hasVideoRoadTag()">
        <tag-data-table :table-data="tableRoadData" :key="UploadVideoTypes.ROAD"></tag-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import { CriticalEvent } from '@/models/map/CriticalEvent'

import { UploadVideoTypes } from '@/enum'
import TagDataTable from '@/components/map/criticalPopup/tagDataTable'

export default {
  name: 'criticalVideoTag',
  components: { TagDataTable },
  props: {
    event: CriticalEvent
  },
  data: () => ({
    tab: 0
  }),
  computed: {
    tableData () {
      return this.prepareTable('videoTag')
    },
    tableRoadData () {
      return this.prepareTable('videoRoadTag')
    }
  },
  methods: {
    prepareTable (field) {
      const videoTag = this.event[field]
      const fields = Object.keys(videoTag)
      const result = []

      for (const field of fields) {
        result.push({
          field,
          value: videoTag[field]
        })
      }

      return result
    }
  },
  created () {
    this['UploadVideoTypes'] = UploadVideoTypes
  }
}
</script>

<style scoped>

</style>
